<template>
	<div>
		<div
			class="modal fade"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h1 class="modal-title">{{ title }}</h1>
						<button
							type="button"
							class="modal-close"
							aria-label="Close"
							@click="close"
						>
							<i class="sk-icon-times"></i>
						</button>
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<slot v-if="sms">
							<SkInput
								ref="phoneInput"
								v-for="(phone, i) in phones"
								:key="`phone-${i}`"
								:name="'Phone Number'"
								:placeholder="'(555) 555-5555'"
								:type="'tel'"
								:validation="phoneRegex"
								v-model="phones[i]"
							/>
							<button
								class="button button-transparent button-auto"
								@click="addPhone"
							>
								<i class="sk-icon-plus"></i>
								Add Phone Number
							</button>
						</slot>
						<slot v-else-if="email">
							<SkInput
								ref="emailInput"
								v-for="(email, i) in emails"
								:key="`email-${i}`"
								:name="'Email'"
								:placeholder="'jsmith@gmail.com'"
								:type="'email'"
								:validation="emailRegex"
								v-model="emails[i]"
							/>
							<button
								class="button button-transparent button-auto"
								@click="addEmail"
							>
								<i class="sk-icon-plus"></i>
								Add Email Address
							</button>
						</slot>
						<button class="button button-primary" @click="share">
							Send Referral Code
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-content >>> .sk-input-wrapper {
	width: 100%;
}

.modal-content >>> .sk-input-wrapper + .sk-input-wrapper {
	margin-top: 15px;
}

.button-transparent {
	align-items: center;
	display: flex;
	padding: 0;
	margin-bottom: 20px;
}

.button-transparent,
.button-transparent:hover,
.button-transparent i {
	font-size: 12px;
	color: var(--sk-grey2);
	font-weight: 400;
}

.button-transparent {
	align-self: flex-start;
}

.button-transparent i {
	margin-right: 10px;
}
</style>

<script>
import { eventBus, EventBusEvents } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"
import Loading from "vue-loading-overlay"
import SkInput from "@/components/common/SkInput.vue"

export default {
	name: "ShareModal",
	components: {
		Loading,
		SkInput
	},
	data: function() {
		return {
			loading: false,
			sms: false,
			email: false,
			phoneRegex: /^$|^[0-9]{10,15}$/,
			emailRegex: /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			phones: [""],
			emails: [""]
		}
	},
	computed: {
		title() {
			return this.sms ? "Share with SMS Text" : "Share with Email"
		}
	},
	methods: {
		open(options) {
			this.sms = false
			this.email = false
			this.phones = [""]
			this.emails = [""]
			if (options.target == "sms") {
				this.sms = true
				this.email = false
			} else if (options.target == "email") {
				this.sms = false
				this.email = true
			} else {
				throw "Share modal requires a target"
			}

			this.loading = false
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		},
		addPhone() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Share Referral Add Phone Clicked"
			})
			this.phones.push("")
		},
		addEmail() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Share Referral Add Email Clicked"
			})
			this.emails.push("")
		},
		formIsValid() {
			let inputs = []
			if (this.sms) {
				inputs = this.$refs.phoneInput
			} else {
				inputs = this.$refs.emailInput
			}
			return inputs.every(input => input.validate && input.validate())
		},
		async share() {
			try {
				this.loading = true
				const phones = this.phones.filter(phone => phone.length > 0)
				const emails = this.emails.filter(email => email.length > 0)
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Send Referral Code",
					data: {
						phone_count: phones.length,
						email_count: emails.length
					}
				})
				if (this.formIsValid()) {
					if (phones.length > 0 || emails.length > 0) {
						await this.$store.dispatch("shareReferral", {
							phones: phones,
							emails: emails
						})
						eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
							message: `Your referral code was shared successfully!`,
							type: NotificationType.SUCCESS
						})
					}
					this.close()
				}
				this.loading = false
			} catch (e) {
				this.loading = false
				eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
					message: `We were unable to share your referral code, please try again.`,
					type: NotificationType.ERROR
				})
				throw e
			}
		}
	}
}
</script>
